import type { FC } from 'react';
import React, { Fragment, useCallback, useContext } from 'react';

import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext';

import {
	defaultEditLoadingValues,
	useEditPageLoadingValues,
	useEditPageLoadingActions,
} from './EditPageLoadingContext';
import { EditPageLoadingComponent } from './EditPageLoadingComponent';

export const EditPageLoadingListener: FC = () => {
	const { push } = useContext(RoutesContext);
	const { contentId, redirectUrl, spaceKey, contentType } = useEditPageLoadingValues();
	const { loadEditor, nativeEditorComponentsPreloader } = useEditPageLoadingActions();

	const redirectToEditor = useCallback(
		(redirectToEditorUrl: string): void => {
			loadEditor(defaultEditLoadingValues);
			push(redirectToEditorUrl);
		},
		[push, loadEditor],
	);

	return (
		<Fragment>
			{!!redirectUrl && (
				<EditPageLoadingComponent
					contentId={contentId}
					spaceKey={spaceKey}
					redirectUrl={redirectUrl}
					redirectToEditor={redirectToEditor}
					nativeEditorComponentsPreloader={nativeEditorComponentsPreloader}
					contentType={contentType}
				/>
			)}
		</Fragment>
	);
};
